<template>
  <div class="mt-2">
    <!--escritorio-->
    <div class="d-none d-sm-none d-md-block">
      <div class="row">
        <div class="col">
          <GoogleMapIframe url_map="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15052.307358046246!2d-99.1770353!3d19.4090857!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x115a1e39b117dc00!2sNieve%20de%20Olla!5e0!3m2!1ses-419!2sco!4v1610323703989!5m2!1ses-419!2sco"/>
          <div class="container">
            <div class="row">
              <div class="col text-mobile-sucursal">
                <p class="color-blue font-general-r mb-5">
                  Alfonso Reyes 122,<br>
                  Hipódromo Condesa, CDMX
                </p>
                <span class="color-blue font-general-r">hola@nievedeolla.com</span><br>
                <span class="color-blue font-general-r">+5527480380</span>
              </div>
              <div class="col d-flex justify-content-end">
                <img class="icon-offices" src="@/assets/store/sucursal/sucursal.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <GoogleMapIframe url_map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d896.0375071897405!2d-99.16007230316922!3d19.42017859304562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff10085c54b3%3A0x28469b5e88faf7c8!2sCasa%20Basalta!5e0!3m2!1ses-419!2sco!4v1689710815404!5m2!1ses-419!2sco"/>
          <div class="container">
            <div class="row">
              <div class="col text-mobile-sucursal">
                <p class="color-blue font-general-r mb-5">
                  Casa Basalta - Colima 159,<br>
                  Roma norte, Cuauhtémoc, 06700, CDMX
                </p>
                <span class="color-blue font-general-r">hola@nievedeolla.com</span><br>
                <span class="color-blue font-general-r">+5527480380</span>
              </div>
              <div class="col d-flex justify-content-end">
                <img class="icon-offices" src="@/assets/store/sucursal/sucursal.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--moviles-->
    <div class="d-block d-sm-block d-md-none">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15052.307358046246!2d-99.1770353!3d19.4090857!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x115a1e39b117dc00!2sNieve%20de%20Olla!5e0!3m2!1ses-419!2sco!4v1610323703989!5m2!1ses-419!2sco"
        class="iframe-map"
        frameborder="0"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0">
      </iframe>
      <MenuMobile/>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d896.0375071897405!2d-99.16007230316922!3d19.42017859304562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff10085c54b3%3A0x28469b5e88faf7c8!2sCasa%20Basalta!5e0!3m2!1ses-419!2sco!4v1689710815404!5m2!1ses-419!2sco"
        class="iframe-map"
        frameborder="0"
        allowfullscreen=""
        aria-hidden="false"
        style="margin-top: 1.5em;"
        tabindex="0">
      </iframe>
    </div>

    <!--
    <v-carousel @change="changeCarouselOffice" height="600" hide-delimiters>
      <v-carousel-item
        v-for="(item,i) in offices"
        :key="i"
        :src="item.url_image"
      ></v-carousel-item>
    </v-carousel>-->
  </div>
</template>

<script>
import GoogleMapIframe from '@/components/store/GoogleMapIframe'

export default {
  components: { GoogleMapIframe }
}
</script>

<!--
<script>
//import HomePageService from '@/services/home.service'

export default {
  data: () => ({
    offices: [],
    detail_office: null
  }),
  methods: {
    changeCarouselOffice(i) {
      this.detail_office = this.offices[i]
    },
    async getOffices() {
      const { data:res } = await HomePageService.getOffices()
      this.offices = res
      this.detail_office = res[0]
    }
  },
  created() {
    //this.getOffices()
  }*/
}
</script>


<style scoped>
  >>>.v-window__prev, >>>.v-window__next {
    background: none;
  }
  >>>.v-icon {
    font-size: 60px !important
  }
</style>-->
